export default function UpdatingEstimate() {
	return (
		<span style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
			<svg
				width="14"
				height="14"
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ flexShrink: 0 }}
			>
				<g>
					<circle cx="7" cy="2.5" r="1.1" fill="#64686A" opacity="1" />
					<circle cx="10.18" cy="3.82" r="1.1" fill="#64686A" opacity="0.875" />
					<circle cx="11.5" cy="7" r="1.1" fill="#64686A" opacity="0.75" />
					<circle cx="10.18" cy="10.18" r="1.1" fill="#64686A" opacity="0.625" />
					<circle cx="7" cy="11.5" r="1.1" fill="#64686A" opacity="0.5" />
					<circle cx="3.82" cy="10.18" r="1.1" fill="#C7CACF" opacity="0.5" />
					<circle cx="2.5" cy="7" r="1.1" fill="#C7CACF" opacity="0.35" />
					<circle cx="3.82" cy="3.82" r="1.1" fill="#C7CACF" opacity="0.2" />
					<animateTransform
						attributeName="transform"
						type="rotate"
						from="0 7 7"
						to="360 7 7"
						dur="0.8s"
						repeatCount="indefinite"
					/>
				</g>
			</svg>
			<span style={{ fontSize: '13px', color: '#9AA3A8', fontFamily: 'Inter', fontWeight: 400 }}>
				Updating estimate
			</span>
		</span>
	);
}
